import { Link, useLocation } from 'react-router-dom';
import { resolveFirstAllowedRoute } from '../../shared/access/route-resolver';
import { useAuth } from '../../shared/auth/use-auth';
import { cn } from '../../shared/lib/cn';
import { getButtonClassNames } from '../../shared/ui/Button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shared/ui/Card';
import { Stack } from '../../shared/ui/Stack';

export default function ModuleUnavailablePage() {
  const { me } = useAuth();
  const location = useLocation();
  const home = resolveFirstAllowedRoute(me?.capabilities ?? null, me);
  const st = (location.state ?? null) as {
    moduleCode?: string;
  } | null;

  return (
    <div className="staff-system-shell">
      <Card className="staff-system-inner">
        <CardHeader>
          <CardTitle>Модуль недоступен</CardTitle>
          <CardDescription>
            Тариф или настройки организации не позволяют открыть этот раздел. Обратитесь к администратору платформы
            или выберите другой раздел в меню.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Stack gap={3}>
            {st?.moduleCode ? (
              <p className="staff-m-0 text-sm text-[hsl(var(--ui-muted-foreground))]">Код модуля: {st.moduleCode}</p>
            ) : null}
            <Link to={home} className={cn(getButtonClassNames({ variant: 'primary' }), 'staff-link-button')}>
              На доступный раздел
            </Link>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );
}
